module.exports = __webpack_public_path__ + "static/img/new-piler.be905fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/new-piler.png
// module id = nyql
// module chunks = 28